// Mock data for SHIRA AI website

export const navLinks = [
  { name: 'About', href: '#about' },
  { name: 'Services', href: '#services' },
  { name: 'Why Us', href: '#why-choose' },
  { name: 'Contact', href: '#contact' }
];

export const services = [
  {
    id: 1,
    title: 'Website & App Development',
    description: 'Portfolio, business websites & scalable mobile/web applications',
    icon: 'Globe'
  },
  {
    id: 2,
    title: 'SaaS Development',
    description: 'Build scalable SaaS products with modern tech stacks and cloud integration',
    icon: 'Cloud'
  },
  {
    id: 3,
    title: 'ATS-Optimized Resumes',
    description: 'Professional resumes engineered to pass Applicant Tracking Systems',
    icon: 'FileText'
  },
  {
    id: 4,
    title: 'LinkedIn Branding & Optimization',
    description: 'Stand out with a strategically crafted, high-impact LinkedIn presence',
    icon: 'Linkedin'
  },
  {
    id: 5,
    title: 'Brand Identity & Logo Design',
    description: 'Distinctive brand identities and logos that leave a lasting impression',
    icon: 'Palette'
  },
  {
    id: 6,
    title: 'Google Business Profile Setup & Optimization',
    description: 'Complete setup and optimization for maximum local search visibility',
    icon: 'MapPin'
  },
  {
    id: 7,
    title: 'Community & NGO Development',
    description: 'Impactful digital solutions for communities and partner NGOs',
    icon: 'Users'
  },
  {
    id: 8,
    title: 'Professional & Industry Training',
    description: 'Targeted skill development programs with leading EdTech partners',
    icon: 'GraduationCap'
  },
  {
    id: 9,
    title: 'AI-Driven Solutions',
    description: 'Intelligent automation and AI tools for accelerated digital transformation',
    icon: 'Sparkles'
  }
];

export const whyChoose = [
  {
    id: 1,
    title: 'AI-Powered Approach',
    description: 'Leveraging cutting-edge AI technology for intelligent solutions',
    icon: 'Brain'
  },
  {
    id: 2,
    title: 'Modern & Creative',
    description: 'Contemporary design execution that stands out',
    icon: 'Sparkle'
  },
  {
    id: 3,
    title: 'Student & Business Friendly',
    description: 'Solutions tailored for everyone from freshers to enterprises',
    icon: 'Heart'
  },
  {
    id: 4,
    title: 'Fast & Reliable',
    description: 'Quick turnaround without compromising on quality',
    icon: 'Zap'
  },
  {
    id: 5,
    title: 'Transparent Process',
    description: 'Honest communication and clear expectations throughout',
    icon: 'Shield'
  },
  {
    id: 6,
    title: 'Proven Results',
    description: 'Track record of successful digital transformations',
    icon: 'TrendingUp'
  }
];

export const contactInfo = {
  email: 'connect.shiraai@gmail.com',
  phone: '+91 8210173404',
  location: 'New Delhi, India'
};

export const impactStats = [
  {
    id: 1,
    title: 'AI-Driven Intelligence',
    description: 'Smart solutions powered by advanced artificial intelligence',
    highlight: 'Intelligence'
  },
  {
    id: 2,
    title: 'Career Transformation',
    description: 'Empowering individuals with professional digital identities',
    highlight: 'Career'
  },
  {
    id: 3,
    title: 'Creative Excellence',
    description: 'Design that captures attention and communicates impact',
    highlight: 'Design'
  }
];
